import { render, staticRenderFns } from "./data-base-list.vue?vue&type=template&id=c9a4d024"
import script from "./data-base-list.vue?vue&type=script&lang=js"
export * from "./data-base-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports